import React from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton, Link, Typography } from '@sunwisesoftware/sunwise-ui';
import { isEmpty, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

const ProductColumns = ({ hiddenColumns, orders }) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    // const formateadorCOP = new Intl.NumberFormat('es-CO', {
    //     style: 'currency',
    //     currency: 'COP',
    //     minimumFractionDigits: 2, // Para mostrar dos decimales
    // });

    let columns = [
        {
            align: 'left',
            display: 'flex',
            field: 'code',
            flex: 1,
            headerName: t('Code'),
            hide: hiddenColumns.includes('code'),
            order: orders?.code,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption" fontWeight="bold">
                        {row.code}
                    </Typography>
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'name',
            flex: 1,
            headerName: t('Name'),
            hide: hiddenColumns.includes('name'),
            order: orders?.name,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption" fontWeight="bold">
                        {row.name}
                    </Typography>
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'weight',
            flex: 1,
            headerName: t('Weight'),
            hide: hiddenColumns.includes('weight'),
            order: orders?.weight,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption" fontWeight="bold">
                        {row.weight || '--'} g
                    </Typography>
                );
            },
        },
        // {
        //     align: 'left',
        //     display: 'flex',
        //     field: 'cost',
        //     flex: 1,
        //     headerName: t('Cost'),
        //     renderCell: (params) => {
        //         const { row } = params;
        //         return (
        //             <Typography variant="caption" fontWeight="bold">
        //                 {formateadorCOP.format(row.cost) || '--'}
        //             </Typography>
        //         );
        //     },
        // },
        {
            align: 'left',
            display: 'flex',
            field: 'data_sheet',
            flex: 1,
            headerName: t('Datasheet'),
            hide: hiddenColumns.includes('data_sheet'),
            order: orders?.data_sheet,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <IconButton
                        component={Link}
                        disabled={isEmpty(row.data_sheet)}
                        href={row.data_sheet}
                        target="_blank"
                    >
                        <VisibilityIcon fontSize="small" />
                    </IconButton>
                );
            },
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = [
            {
                align: 'left',
                display: 'flex',
                field: 'name',
                flex: 1,
                headerName: t('Name'),
                hide: hiddenColumns.includes('name'),
                order: orders?.name,
                renderCell: (params) => {
                    const { row } = params;
                    return (
                        <Typography variant="caption" fontWeight="bold">
                            {row.name}
                        </Typography>
                    );
                },
            },
        ];
    }

    return orderBy(columns, ['order'], ['asc']);
};

ProductColumns.propTypes = {
    hiddenColumns: PropTypes.array,
    orders: PropTypes.object,
};

export default ProductColumns;
